import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-delete",
  "use": "icon-delete-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-delete\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M16.22,8.44V6.58a.89.89,0,0,0-.9-.88H8.68a.89.89,0,0,0-.9.88V8.44H5.7v1.75H6.9v7.23a.89.89,0,0,0,.9.88h8.4a.89.89,0,0,0,.9-.88V10.19h1.2V8.44Zm-6.64,0v-1h4.84v1Zm5.72,1.75v6.35H8.7V10.19Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol